module.exports = __webpack_public_path__ + "static/img/spacestudio-blanc.c8193e0.png";